export const validation = {
  maxTitleChar: 100,
  maxParagraphChar: 500,
  musicUrls: {
    min: 1,
    max: 12
  }
}
